import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import {
  endDateValidationRule,
  regionsRule,
  requiredDateRule,
} from "../../../../../../utils/validationUtils";

import { TFlyerDetailFormat } from "../../../../types/flyer-detail-data/flyer-detail-data.interface";

export const flyerDetailFormValidation = yupResolver(
  yup.object({
    format: yup.string().oneOf(["Print", "Digital", "Both"] as TFlyerDetailFormat[]),
    objective: yup.string(),
    regions: regionsRule,
    startAt: yup.date().required(),
    endAt: endDateValidationRule,
    wtwReviewDate: requiredDateRule("Please enter a WTW Review Date."),
    wtwSeniorReviewDate: requiredDateRule("Please enter a WTW Senior Review Date."),
  })
);
